/* tslint:disable */
/* eslint-disable */
/* @relayHash 77fa0ed9aa07b7785a605aed54429d9d */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type ReplyListContainer2PaginationQueryVariables = {
    count: number;
    cursor?: unknown | null;
    orderBy: COMMENT_SORT;
    commentID: string;
    flattenReplies: boolean;
    refreshStream: boolean;
};
export type ReplyListContainer2PaginationQueryResponse = {
    readonly comment: {
        readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer2_comment">;
    } | null;
};
export type ReplyListContainer2PaginationQuery = {
    readonly response: ReplyListContainer2PaginationQueryResponse;
    readonly variables: ReplyListContainer2PaginationQueryVariables;
};



/*
query ReplyListContainer2PaginationQuery(
  $count: Int!
  $cursor: Cursor
  $orderBy: COMMENT_SORT!
  $commentID: ID!
  $flattenReplies: Boolean!
  $refreshStream: Boolean!
) {
  comment(id: $commentID) {
    ...ReplyListContainer2_comment_206hzj
    id
  }
}

fragment ArchivedReportFlowContainer_comment on Comment {
  id
  story {
    url
    id
  }
}

fragment CaretContainer_comment on Comment {
  id
  ...ModerationDropdownContainer_comment
}

fragment CommentContainer_comment on Comment {
  id
  author {
    id
    username
    avatar
    badges
    featuredCommenter
    newCommenter
  }
  parent {
    id
    author {
      username
      id
    }
  }
  body
  createdAt
  status
  rating
  editing {
    edited
    editableUntil
  }
  tags {
    code
  }
  deleted
  actionCounts {
    reaction {
      total
    }
  }
  viewerActionPresence {
    dontAgree
    flag
  }
  seen
  canReply
  ...CaretContainer_comment
  ...EditCommentFormContainer_comment
  ...MediaSectionContainer_comment
  ...ReactionButtonContainer_comment
  ...ModerationRejectedTombstoneContainer_comment
  ...ReplyCommentFormContainer_comment
  ...ReportButton_comment
  ...ReportFlowContainer_comment
  ...UsernameContainer_comment
  ...UsernameWithPopoverContainer_comment
  ...UserTagsContainer_comment
  ...ArchivedReportFlowContainer_comment
}

fragment CopyCommentEmbedCodeContainer_comment on Comment {
  id
  author {
    id
    username
  }
  body
  revision {
    id
    media {
      __typename
      ... on GiphyMedia {
        url
      }
      ... on TwitterMedia {
        url
      }
      ... on BlueskyMedia {
        url
      }
      ... on YouTubeMedia {
        url
      }
      ... on ExternalMedia {
        url
      }
    }
  }
}

fragment DeletedTombstoneContainer_comment on Comment {
  deleted
  id
}

fragment EditCommentFormContainer_comment on Comment {
  id
  body
  createdAt
  revision {
    id
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TenorMedia {
        url
        title
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on BlueskyMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
  }
  author {
    username
    id
  }
  editing {
    editableUntil
  }
  site {
    id
  }
}

fragment IgnoredTombstoneOrHideContainer_comment on Comment {
  id
  author {
    id
    username
  }
}

fragment LocalReplyListContainer_comment on Comment {
  id
}

fragment MediaSectionContainer_comment on Comment {
  id
  site {
    id
  }
  revision {
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TenorMedia {
        url
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on BlueskyMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
    id
  }
}

fragment ModerationActionsContainer_comment on Comment {
  id
  author {
    id
  }
  body
  revision {
    id
  }
  status
  tags {
    code
  }
  ...CopyCommentEmbedCodeContainer_comment
}

fragment ModerationDropdownContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  status
  tags {
    code
  }
  ...ModerationActionsContainer_comment
  ...UserBanPopoverContainer_comment
}

fragment ModerationRejectedTombstoneContainer_comment on Comment {
  id
  ...CaretContainer_comment
}

fragment ReactionButtonContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  viewerActionPresence {
    reaction
  }
  actionCounts {
    reaction {
      total
    }
  }
}

fragment ReplyCommentFormContainer_comment on Comment {
  id
  site {
    id
  }
  author {
    username
    id
  }
  revision {
    id
  }
  ...ReplyEditedWarningContainer_comment
}

fragment ReplyEditedWarningContainer_comment on Comment {
  editing {
    edited
  }
  revision {
    id
  }
}

fragment ReplyListCommentContainer_comment on Comment {
  ...CommentContainer_comment
  ...IgnoredTombstoneOrHideContainer_comment
  ...DeletedTombstoneContainer_comment
}

fragment ReplyListContainer2_comment_206hzj on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: $count, after: $cursor, orderBy: $orderBy, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer3_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer3_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer4_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer4_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer5_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer5_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer6_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer6_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainerLast_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainerLastFlattened_comment on Comment {
  status
  id
  ...ReplyListContainer_comment_1fYj9E
  replies(first: 10, orderBy: CREATED_AT_ASC, flatten: $flattenReplies, refreshStream: false) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        __typename
      }
      __typename
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainerLast_comment_4768Eu on Comment {
  ...LocalReplyListContainer_comment @skip(if: $flattenReplies)
  ...ReplyListContainerLastFlattened_comment @include(if: $flattenReplies)
}

fragment ReplyListContainer_comment_1fYj9E on Comment {
  id
  status
}

fragment ReplyListContainer_comment_4768Eu on Comment {
  id
  status
}

fragment ReportButton_comment on Comment {
  id
  author {
    username
    id
  }
  viewerActionPresence {
    dontAgree
    flag
    illegal
  }
}

fragment ReportCommentFormContainer_comment on Comment {
  id
  revision {
    id
  }
  story {
    url
    id
  }
}

fragment ReportFlowContainer_comment on Comment {
  ...ReportCommentFormContainer_comment
  id
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment UserBanPopoverContainer_comment on Comment {
  id
  revision {
    id
  }
  status
  author {
    id
    username
  }
}

fragment UserIgnorePopoverContainer_user on User {
  id
  username
}

fragment UserPopoverContainer_user on User {
  id
  ...UserPopoverOverviewContainer_user
  ...UserIgnorePopoverContainer_user
}

fragment UserPopoverOverviewContainer_user on User {
  id
  username
  createdAt
  ignoreable
  bio
}

fragment UserTagsContainer_comment on Comment {
  tags {
    code
  }
}

fragment UsernameContainer_comment on Comment {
  id
  author {
    username
    id
  }
}

fragment UsernameWithPopoverContainer_comment on Comment {
  id
  author {
    id
    username
    ...UserPopoverContainer_user
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentID"
    } as any), v1 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    } as any), v2 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cursor"
    } as any), v3 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "flattenReplies"
    } as any), v4 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orderBy"
    } as any), v5 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "refreshStream"
    } as any), v6 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "commentID"
        } as any)
    ], v7 = ({
        "kind": "Variable",
        "name": "orderBy",
        "variableName": "orderBy"
    } as any), v8 = ({
        "kind": "Variable",
        "name": "refreshStream",
        "variableName": "refreshStream"
    } as any), v9 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any), v10 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v11 = [
        ({
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        } as any),
        ({
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        } as any),
        (v7 /*: any*/),
        (v8 /*: any*/)
    ], v12 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "replyCount",
        "storageKey": null
    } as any), v13 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any), v14 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
    } as any), v15 = ({
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            (v10 /*: any*/),
            (v13 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avatar",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "badges",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "featuredCommenter",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "newCommenter",
                "storageKey": null
            },
            (v14 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ignoreable",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bio",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v16 = ({
        "alias": null,
        "args": null,
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": [
            (v10 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    (v13 /*: any*/),
                    (v10 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v17 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "body",
        "storageKey": null
    } as any), v18 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rating",
        "storageKey": null
    } as any), v19 = ({
        "alias": null,
        "args": null,
        "concreteType": "EditInfo",
        "kind": "LinkedField",
        "name": "editing",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "edited",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "editableUntil",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v20 = ({
        "alias": null,
        "args": null,
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tags",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v21 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
    } as any), v22 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionCounts",
        "kind": "LinkedField",
        "name": "actionCounts",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ReactionActionCounts",
                "kind": "LinkedField",
                "name": "reaction",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v23 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionPresence",
        "kind": "LinkedField",
        "name": "viewerActionPresence",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dontAgree",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flag",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reaction",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "illegal",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v24 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "seen",
        "storageKey": null
    } as any), v25 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canReply",
        "storageKey": null
    } as any), v26 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any), v27 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    } as any), v28 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any), v29 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
    } as any), v30 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
    } as any), v31 = [
        (v27 /*: any*/),
        (v29 /*: any*/)
    ], v32 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentRevision",
        "kind": "LinkedField",
        "name": "revision",
        "plural": false,
        "selections": [
            (v10 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                    (v26 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v27 /*: any*/),
                            (v28 /*: any*/),
                            (v29 /*: any*/),
                            (v30 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "still",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "video",
                                "storageKey": null
                            }
                        ],
                        "type": "GiphyMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": (v31 /*: any*/),
                        "type": "TwitterMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": (v31 /*: any*/),
                        "type": "BlueskyMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v27 /*: any*/),
                            (v29 /*: any*/),
                            (v30 /*: any*/)
                        ],
                        "type": "YouTubeMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v27 /*: any*/)
                        ],
                        "type": "ExternalMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v27 /*: any*/),
                            (v28 /*: any*/)
                        ],
                        "type": "TenorMedia",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v33 = ({
        "alias": null,
        "args": null,
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
            (v10 /*: any*/)
        ],
        "storageKey": null
    } as any), v34 = ({
        "alias": null,
        "args": null,
        "concreteType": "Story",
        "kind": "LinkedField",
        "name": "story",
        "plural": false,
        "selections": [
            (v27 /*: any*/),
            (v10 /*: any*/)
        ],
        "storageKey": null
    } as any), v35 = ({
        "kind": "Literal",
        "name": "first",
        "value": 10
    } as any), v36 = ({
        "kind": "Literal",
        "name": "orderBy",
        "value": "CREATED_AT_ASC"
    } as any), v37 = [
        (v35 /*: any*/),
        (v36 /*: any*/),
        (v8 /*: any*/)
    ], v38 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "spamBanned",
        "storageKey": null
    } as any), v39 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pending",
        "storageKey": null
    } as any), v40 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastViewerAction",
        "storageKey": null
    } as any), v41 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasTraversalFocus",
        "storageKey": null
    } as any), v42 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enteredLive",
        "storageKey": null
    } as any), v43 = ({
        "kind": "ClientExtension",
        "selections": [
            (v38 /*: any*/),
            (v39 /*: any*/),
            (v40 /*: any*/),
            (v41 /*: any*/),
            (v42 /*: any*/)
        ]
    } as any), v44 = [
        ({
            "alias": null,
            "args": null,
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "localReplies",
            "plural": true,
            "selections": [
                (v10 /*: any*/),
                (v42 /*: any*/),
                (v15 /*: any*/),
                (v16 /*: any*/),
                (v17 /*: any*/),
                (v14 /*: any*/),
                (v9 /*: any*/),
                (v18 /*: any*/),
                (v19 /*: any*/),
                (v20 /*: any*/),
                (v39 /*: any*/),
                (v40 /*: any*/),
                (v21 /*: any*/),
                (v22 /*: any*/),
                (v23 /*: any*/),
                (v41 /*: any*/),
                (v24 /*: any*/),
                (v25 /*: any*/),
                (v38 /*: any*/),
                (v32 /*: any*/),
                (v33 /*: any*/),
                (v34 /*: any*/)
            ],
            "storageKey": null
        } as any)
    ], v45 = ({
        "kind": "Literal",
        "name": "refreshStream",
        "value": false
    } as any), v46 = [
        (v35 /*: any*/),
        ({
            "kind": "Variable",
            "name": "flatten",
            "variableName": "flattenReplies"
        } as any),
        (v36 /*: any*/),
        (v45 /*: any*/)
    ], v47 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    } as any), v48 = ({
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v49 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v47 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v10 /*: any*/),
                    (v12 /*: any*/),
                    (v42 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v17 /*: any*/),
                    (v14 /*: any*/),
                    (v9 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    (v39 /*: any*/),
                    (v40 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v41 /*: any*/),
                    (v24 /*: any*/),
                    (v25 /*: any*/),
                    (v38 /*: any*/),
                    (v32 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v50 = [
        "orderBy",
        "refreshStream"
    ], v51 = ({
        "alias": null,
        "args": (v46 /*: any*/),
        "filters": (v50 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v52 = ({
        "condition": "flattenReplies",
        "kind": "Condition",
        "passingValue": false,
        "selections": (v44 /*: any*/)
    } as any), v53 = ({
        "condition": "flattenReplies",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": null,
                "args": (v46 /*: any*/),
                "concreteType": "CommentsConnection",
                "kind": "LinkedField",
                "name": "replies",
                "plural": false,
                "selections": [
                    (v49 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v10 /*: any*/),
                                    (v12 /*: any*/),
                                    (v42 /*: any*/),
                                    (v15 /*: any*/),
                                    (v16 /*: any*/),
                                    (v17 /*: any*/),
                                    (v14 /*: any*/),
                                    (v9 /*: any*/),
                                    (v18 /*: any*/),
                                    (v19 /*: any*/),
                                    (v20 /*: any*/),
                                    (v39 /*: any*/),
                                    (v40 /*: any*/),
                                    (v21 /*: any*/),
                                    (v22 /*: any*/),
                                    (v23 /*: any*/),
                                    (v41 /*: any*/),
                                    (v24 /*: any*/),
                                    (v25 /*: any*/),
                                    (v38 /*: any*/),
                                    (v32 /*: any*/),
                                    (v33 /*: any*/),
                                    (v34 /*: any*/),
                                    (v26 /*: any*/)
                                ],
                                "storageKey": null
                            },
                            (v26 /*: any*/),
                            (v47 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v48 /*: any*/)
                ],
                "storageKey": null
            },
            (v51 /*: any*/)
        ]
    } as any), v54 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v47 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v10 /*: any*/),
                    (v12 /*: any*/),
                    (v42 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v17 /*: any*/),
                    (v14 /*: any*/),
                    (v9 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    (v39 /*: any*/),
                    (v40 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v41 /*: any*/),
                    (v24 /*: any*/),
                    (v25 /*: any*/),
                    (v38 /*: any*/),
                    (v32 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v52 /*: any*/),
                    (v53 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v55 = ({
        "alias": null,
        "args": (v37 /*: any*/),
        "filters": (v50 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v56 = [
        (v35 /*: any*/),
        (v36 /*: any*/),
        (v45 /*: any*/)
    ], v57 = ({
        "alias": null,
        "args": (v56 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v54 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v10 /*: any*/),
                            (v12 /*: any*/),
                            (v42 /*: any*/),
                            (v15 /*: any*/),
                            (v16 /*: any*/),
                            (v17 /*: any*/),
                            (v14 /*: any*/),
                            (v9 /*: any*/),
                            (v18 /*: any*/),
                            (v19 /*: any*/),
                            (v20 /*: any*/),
                            (v39 /*: any*/),
                            (v40 /*: any*/),
                            (v21 /*: any*/),
                            (v22 /*: any*/),
                            (v23 /*: any*/),
                            (v41 /*: any*/),
                            (v24 /*: any*/),
                            (v25 /*: any*/),
                            (v38 /*: any*/),
                            (v32 /*: any*/),
                            (v33 /*: any*/),
                            (v34 /*: any*/),
                            (v26 /*: any*/),
                            (v52 /*: any*/),
                            (v53 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v47 /*: any*/)
                ],
                "storageKey": null
            },
            (v48 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\",refreshStream:false)"
    } as any), v58 = ({
        "alias": null,
        "args": (v56 /*: any*/),
        "filters": (v50 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v59 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v47 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v10 /*: any*/),
                    (v12 /*: any*/),
                    (v42 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v17 /*: any*/),
                    (v14 /*: any*/),
                    (v9 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    (v39 /*: any*/),
                    (v40 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v41 /*: any*/),
                    (v24 /*: any*/),
                    (v25 /*: any*/),
                    (v38 /*: any*/),
                    (v32 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v57 /*: any*/),
                    (v58 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v60 = ({
        "alias": null,
        "args": (v56 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v59 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v10 /*: any*/),
                            (v12 /*: any*/),
                            (v42 /*: any*/),
                            (v15 /*: any*/),
                            (v16 /*: any*/),
                            (v17 /*: any*/),
                            (v14 /*: any*/),
                            (v9 /*: any*/),
                            (v18 /*: any*/),
                            (v19 /*: any*/),
                            (v20 /*: any*/),
                            (v39 /*: any*/),
                            (v40 /*: any*/),
                            (v21 /*: any*/),
                            (v22 /*: any*/),
                            (v23 /*: any*/),
                            (v41 /*: any*/),
                            (v24 /*: any*/),
                            (v25 /*: any*/),
                            (v38 /*: any*/),
                            (v32 /*: any*/),
                            (v33 /*: any*/),
                            (v34 /*: any*/),
                            (v57 /*: any*/),
                            (v58 /*: any*/),
                            (v26 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v47 /*: any*/)
                ],
                "storageKey": null
            },
            (v48 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\",refreshStream:false)"
    } as any), v61 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v47 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v10 /*: any*/),
                    (v12 /*: any*/),
                    (v42 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v17 /*: any*/),
                    (v14 /*: any*/),
                    (v9 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    (v39 /*: any*/),
                    (v40 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v41 /*: any*/),
                    (v24 /*: any*/),
                    (v25 /*: any*/),
                    (v38 /*: any*/),
                    (v32 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v60 /*: any*/),
                    (v58 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v62 = ({
        "alias": null,
        "args": (v56 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v61 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v10 /*: any*/),
                            (v12 /*: any*/),
                            (v42 /*: any*/),
                            (v15 /*: any*/),
                            (v16 /*: any*/),
                            (v17 /*: any*/),
                            (v14 /*: any*/),
                            (v9 /*: any*/),
                            (v18 /*: any*/),
                            (v19 /*: any*/),
                            (v20 /*: any*/),
                            (v39 /*: any*/),
                            (v40 /*: any*/),
                            (v21 /*: any*/),
                            (v22 /*: any*/),
                            (v23 /*: any*/),
                            (v41 /*: any*/),
                            (v24 /*: any*/),
                            (v25 /*: any*/),
                            (v38 /*: any*/),
                            (v32 /*: any*/),
                            (v33 /*: any*/),
                            (v34 /*: any*/),
                            (v60 /*: any*/),
                            (v58 /*: any*/),
                            (v26 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v47 /*: any*/)
                ],
                "storageKey": null
            },
            (v48 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\",refreshStream:false)"
    } as any), v63 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v47 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v10 /*: any*/),
                    (v12 /*: any*/),
                    (v42 /*: any*/),
                    (v15 /*: any*/),
                    (v16 /*: any*/),
                    (v17 /*: any*/),
                    (v14 /*: any*/),
                    (v9 /*: any*/),
                    (v18 /*: any*/),
                    (v19 /*: any*/),
                    (v20 /*: any*/),
                    (v39 /*: any*/),
                    (v40 /*: any*/),
                    (v21 /*: any*/),
                    (v22 /*: any*/),
                    (v23 /*: any*/),
                    (v41 /*: any*/),
                    (v24 /*: any*/),
                    (v25 /*: any*/),
                    (v38 /*: any*/),
                    (v32 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v62 /*: any*/),
                    (v58 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any);
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/),
                (v5 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "ReplyListContainer2PaginationQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v6 /*: any*/),
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "comment",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "count",
                                    "variableName": "count"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "cursor",
                                    "variableName": "cursor"
                                },
                                (v7 /*: any*/),
                                (v8 /*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "ReplyListContainer2_comment"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v4 /*: any*/),
                (v0 /*: any*/),
                (v3 /*: any*/),
                (v5 /*: any*/)
            ],
            "kind": "Operation",
            "name": "ReplyListContainer2PaginationQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v6 /*: any*/),
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "comment",
                    "plural": false,
                    "selections": [
                        (v9 /*: any*/),
                        (v10 /*: any*/),
                        {
                            "alias": null,
                            "args": (v11 /*: any*/),
                            "concreteType": "CommentsConnection",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                (v10 /*: any*/),
                                                (v12 /*: any*/),
                                                (v15 /*: any*/),
                                                (v16 /*: any*/),
                                                (v17 /*: any*/),
                                                (v14 /*: any*/),
                                                (v9 /*: any*/),
                                                (v18 /*: any*/),
                                                (v19 /*: any*/),
                                                (v20 /*: any*/),
                                                (v21 /*: any*/),
                                                (v22 /*: any*/),
                                                (v23 /*: any*/),
                                                (v24 /*: any*/),
                                                (v25 /*: any*/),
                                                (v32 /*: any*/),
                                                (v33 /*: any*/),
                                                (v34 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": (v37 /*: any*/),
                                                    "concreteType": "CommentsConnection",
                                                    "kind": "LinkedField",
                                                    "name": "replies",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CommentEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Comment",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v10 /*: any*/),
                                                                        (v12 /*: any*/),
                                                                        (v15 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        (v14 /*: any*/),
                                                                        (v9 /*: any*/),
                                                                        (v18 /*: any*/),
                                                                        (v19 /*: any*/),
                                                                        (v20 /*: any*/),
                                                                        (v21 /*: any*/),
                                                                        (v22 /*: any*/),
                                                                        (v23 /*: any*/),
                                                                        (v24 /*: any*/),
                                                                        (v25 /*: any*/),
                                                                        (v32 /*: any*/),
                                                                        (v33 /*: any*/),
                                                                        (v34 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": (v37 /*: any*/),
                                                                            "concreteType": "CommentsConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "replies",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "CommentEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Comment",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v10 /*: any*/),
                                                                                                (v12 /*: any*/),
                                                                                                (v15 /*: any*/),
                                                                                                (v16 /*: any*/),
                                                                                                (v17 /*: any*/),
                                                                                                (v14 /*: any*/),
                                                                                                (v9 /*: any*/),
                                                                                                (v18 /*: any*/),
                                                                                                (v19 /*: any*/),
                                                                                                (v20 /*: any*/),
                                                                                                (v21 /*: any*/),
                                                                                                (v22 /*: any*/),
                                                                                                (v23 /*: any*/),
                                                                                                (v24 /*: any*/),
                                                                                                (v25 /*: any*/),
                                                                                                (v32 /*: any*/),
                                                                                                (v33 /*: any*/),
                                                                                                (v34 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": (v37 /*: any*/),
                                                                                                    "concreteType": "CommentsConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "replies",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "CommentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "Comment",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        (v10 /*: any*/),
                                                                                                                        (v12 /*: any*/),
                                                                                                                        (v15 /*: any*/),
                                                                                                                        (v16 /*: any*/),
                                                                                                                        (v17 /*: any*/),
                                                                                                                        (v14 /*: any*/),
                                                                                                                        (v9 /*: any*/),
                                                                                                                        (v18 /*: any*/),
                                                                                                                        (v19 /*: any*/),
                                                                                                                        (v20 /*: any*/),
                                                                                                                        (v21 /*: any*/),
                                                                                                                        (v22 /*: any*/),
                                                                                                                        (v23 /*: any*/),
                                                                                                                        (v24 /*: any*/),
                                                                                                                        (v25 /*: any*/),
                                                                                                                        (v32 /*: any*/),
                                                                                                                        (v33 /*: any*/),
                                                                                                                        (v34 /*: any*/),
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": (v37 /*: any*/),
                                                                                                                            "concreteType": "CommentsConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "replies",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "alias": null,
                                                                                                                                    "args": null,
                                                                                                                                    "concreteType": "CommentEdge",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "edges",
                                                                                                                                    "plural": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "alias": null,
                                                                                                                                            "args": null,
                                                                                                                                            "concreteType": "Comment",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "node",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                (v10 /*: any*/),
                                                                                                                                                (v12 /*: any*/),
                                                                                                                                                (v15 /*: any*/),
                                                                                                                                                (v16 /*: any*/),
                                                                                                                                                (v17 /*: any*/),
                                                                                                                                                (v14 /*: any*/),
                                                                                                                                                (v9 /*: any*/),
                                                                                                                                                (v18 /*: any*/),
                                                                                                                                                (v19 /*: any*/),
                                                                                                                                                (v20 /*: any*/),
                                                                                                                                                (v21 /*: any*/),
                                                                                                                                                (v22 /*: any*/),
                                                                                                                                                (v23 /*: any*/),
                                                                                                                                                (v24 /*: any*/),
                                                                                                                                                (v25 /*: any*/),
                                                                                                                                                (v32 /*: any*/),
                                                                                                                                                (v33 /*: any*/),
                                                                                                                                                (v34 /*: any*/),
                                                                                                                                                (v26 /*: any*/),
                                                                                                                                                (v43 /*: any*/),
                                                                                                                                                {
                                                                                                                                                    "condition": "flattenReplies",
                                                                                                                                                    "kind": "Condition",
                                                                                                                                                    "passingValue": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "ClientExtension",
                                                                                                                                                            "selections": (v44 /*: any*/)
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "condition": "flattenReplies",
                                                                                                                                                    "kind": "Condition",
                                                                                                                                                    "passingValue": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "alias": null,
                                                                                                                                                            "args": (v46 /*: any*/),
                                                                                                                                                            "concreteType": "CommentsConnection",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "replies",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "alias": null,
                                                                                                                                                                    "args": null,
                                                                                                                                                                    "concreteType": "CommentEdge",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "edges",
                                                                                                                                                                    "plural": true,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        {
                                                                                                                                                                            "alias": null,
                                                                                                                                                                            "args": null,
                                                                                                                                                                            "concreteType": "Comment",
                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                            "name": "node",
                                                                                                                                                                            "plural": false,
                                                                                                                                                                            "selections": [
                                                                                                                                                                                (v10 /*: any*/),
                                                                                                                                                                                (v12 /*: any*/),
                                                                                                                                                                                (v15 /*: any*/),
                                                                                                                                                                                (v16 /*: any*/),
                                                                                                                                                                                (v17 /*: any*/),
                                                                                                                                                                                (v14 /*: any*/),
                                                                                                                                                                                (v9 /*: any*/),
                                                                                                                                                                                (v18 /*: any*/),
                                                                                                                                                                                (v19 /*: any*/),
                                                                                                                                                                                (v20 /*: any*/),
                                                                                                                                                                                (v21 /*: any*/),
                                                                                                                                                                                (v22 /*: any*/),
                                                                                                                                                                                (v23 /*: any*/),
                                                                                                                                                                                (v24 /*: any*/),
                                                                                                                                                                                (v25 /*: any*/),
                                                                                                                                                                                (v32 /*: any*/),
                                                                                                                                                                                (v33 /*: any*/),
                                                                                                                                                                                (v34 /*: any*/),
                                                                                                                                                                                (v26 /*: any*/),
                                                                                                                                                                                (v43 /*: any*/)
                                                                                                                                                                            ],
                                                                                                                                                                            "storageKey": null
                                                                                                                                                                        },
                                                                                                                                                                        (v26 /*: any*/),
                                                                                                                                                                        (v47 /*: any*/)
                                                                                                                                                                    ],
                                                                                                                                                                    "storageKey": null
                                                                                                                                                                },
                                                                                                                                                                (v48 /*: any*/),
                                                                                                                                                                {
                                                                                                                                                                    "kind": "ClientExtension",
                                                                                                                                                                    "selections": [
                                                                                                                                                                        (v49 /*: any*/)
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ],
                                                                                                                                                            "storageKey": null
                                                                                                                                                        },
                                                                                                                                                        (v51 /*: any*/)
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "storageKey": null
                                                                                                                                        },
                                                                                                                                        (v47 /*: any*/)
                                                                                                                                    ],
                                                                                                                                    "storageKey": null
                                                                                                                                },
                                                                                                                                (v48 /*: any*/),
                                                                                                                                {
                                                                                                                                    "kind": "ClientExtension",
                                                                                                                                    "selections": [
                                                                                                                                        (v54 /*: any*/)
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        (v55 /*: any*/),
                                                                                                                        (v26 /*: any*/),
                                                                                                                        (v43 /*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                (v47 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        (v48 /*: any*/),
                                                                                                        {
                                                                                                            "kind": "ClientExtension",
                                                                                                            "selections": [
                                                                                                                (v59 /*: any*/)
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v55 /*: any*/),
                                                                                                (v26 /*: any*/),
                                                                                                (v43 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v47 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v48 /*: any*/),
                                                                                {
                                                                                    "kind": "ClientExtension",
                                                                                    "selections": [
                                                                                        (v61 /*: any*/)
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v55 /*: any*/),
                                                                        (v26 /*: any*/),
                                                                        (v43 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v47 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v48 /*: any*/),
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                (v63 /*: any*/)
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v55 /*: any*/),
                                                (v26 /*: any*/),
                                                (v43 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v47 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                (v48 /*: any*/),
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CommentEdge",
                                            "kind": "LinkedField",
                                            "name": "viewNewEdges",
                                            "plural": true,
                                            "selections": [
                                                (v47 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v10 /*: any*/),
                                                        (v12 /*: any*/),
                                                        (v42 /*: any*/),
                                                        (v15 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v14 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v18 /*: any*/),
                                                        (v19 /*: any*/),
                                                        (v20 /*: any*/),
                                                        (v39 /*: any*/),
                                                        (v40 /*: any*/),
                                                        (v21 /*: any*/),
                                                        (v22 /*: any*/),
                                                        (v23 /*: any*/),
                                                        (v41 /*: any*/),
                                                        (v24 /*: any*/),
                                                        (v25 /*: any*/),
                                                        (v38 /*: any*/),
                                                        (v32 /*: any*/),
                                                        (v33 /*: any*/),
                                                        (v34 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": (v56 /*: any*/),
                                                            "concreteType": "CommentsConnection",
                                                            "kind": "LinkedField",
                                                            "name": "replies",
                                                            "plural": false,
                                                            "selections": [
                                                                (v63 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "CommentEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Comment",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v10 /*: any*/),
                                                                                (v12 /*: any*/),
                                                                                (v42 /*: any*/),
                                                                                (v15 /*: any*/),
                                                                                (v16 /*: any*/),
                                                                                (v17 /*: any*/),
                                                                                (v14 /*: any*/),
                                                                                (v9 /*: any*/),
                                                                                (v18 /*: any*/),
                                                                                (v19 /*: any*/),
                                                                                (v20 /*: any*/),
                                                                                (v39 /*: any*/),
                                                                                (v40 /*: any*/),
                                                                                (v21 /*: any*/),
                                                                                (v22 /*: any*/),
                                                                                (v23 /*: any*/),
                                                                                (v41 /*: any*/),
                                                                                (v24 /*: any*/),
                                                                                (v25 /*: any*/),
                                                                                (v38 /*: any*/),
                                                                                (v32 /*: any*/),
                                                                                (v33 /*: any*/),
                                                                                (v34 /*: any*/),
                                                                                (v62 /*: any*/),
                                                                                (v58 /*: any*/),
                                                                                (v26 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v47 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v48 /*: any*/)
                                                            ],
                                                            "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\",refreshStream:false)"
                                                        },
                                                        (v58 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v11 /*: any*/),
                            "filters": (v50 /*: any*/),
                            "handle": "connection",
                            "key": "ReplyList_replies",
                            "kind": "LinkedHandle",
                            "name": "replies"
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                (v39 /*: any*/),
                                (v40 /*: any*/)
                            ]
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "77fa0ed9aa07b7785a605aed54429d9d",
            "metadata": {},
            "name": "ReplyListContainer2PaginationQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '5a6eae193c224dd1c75e031cf098b688';
export default node;
